import { createFileRoute } from "@tanstack/react-router";
import AdminPopularNamesPage from "@/admin/pages/popular-names";

export const Route = createFileRoute("/admin/popular-names")({
  component: AdminPopularNamesPage,
});
